import { render, staticRenderFns } from "./BsTextarea.vue?vue&type=template&id=f68689ae&"
import script from "./BsTextarea.vue?vue&type=script&lang=js&"
export * from "./BsTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports